export const FFC_LOCAL_STORAGE = "viewFulfillmentCenters";
export const IN_STOCK_PRODUCTS_LOCAL_STORAGE = "viewInStockProducts";
export const USER_ID_LOCAL_STORAGE = "user-id";
